import React, { Component } from 'react'
import { Resource, ProjectInfo, ResourceDetails } from '../../schema/types.d'

interface ResourceAttributeRowProps {
  title1: string
  value1: string
  title2: string
  value2: string
}

class ResourceAttributeRow extends Component<ResourceAttributeRowProps> {
  render() {
    const { title1, value1, title2, value2 } = this.props
    return (
      <li className="lh-copy pa1 ph0-l bb b--black-10">
        <div className="dt dt--fixed w-100">
          <div className="dtc mt2">
            <span className="f7 black-70">{title1} </span>
            <span className="f7 black-50">{value1}</span>
          </div>
          <div className="dtc pl3 mt2 ">
            <span className="f7 black-70">{title2} </span>
            <span className="f7 black-50">{value2}</span>
          </div>
        </div>
      </li>
    )
  }
}

function Collapsible(props) {
  const elementId = props.id + '_collapsible'
  return (
    <div className="wrap-collabsible mt2">
      <input id={elementId} className="collapsible toggle" type="checkbox" />
      <label htmlFor={elementId} className="lbl-toggle f7 black-70">
        {props.title}
      </label>
      <div className="collapsible-content">
        <ul className="content-inner">{props.children}</ul>
      </div>
    </div>
  )
}

interface RegistrationsProps {
  registrations: ResourceDetails.Registrations[]
}

class Registrations extends Component<RegistrationsProps> {
  formatDate(dateString: string) {
    let d = new Date(dateString)
    return d.getDay() + '/' + (d.getMonth() + 1) + '/' + d.getFullYear()
  }

  render() {
    return (
      <Collapsible title="Registrations" id="registrations">
        {this.props.registrations.map(r => (
          <li key={r.id}>
            <div className="f7 black-70">{r.licenseType}</div>
            <div className="f7 black-50">
              Member #{r.registrationNumber}| Joined:
              {this.formatDate(r.issueDate)}
            </div>
          </li>
        ))}
      </Collapsible>
    )
  }
}

interface ProjectsProps {
  id: string
  title: string
  projects: ProjectInfo.Fragment[]
}

class Projects extends Component<ProjectsProps> {
  render() {
    return (
      <Collapsible title={this.props.title} id={this.props.id}>
        {this.props.projects.map(p => (
          <li key={p.id}>
            <div className="f7 black-70">{p.projectNumber}</div>
            <div className="f7 black-50">{p.name}</div>
          </li>
        ))}
      </Collapsible>
    )
  }
}

interface ResourceDetailsPopUpProps {
  id: string
  onCloseClick: () => void
}

class ResourceDetailsPopUp extends Component<ResourceDetailsPopUpProps> {
  constructor(props) {
    super(props)
    this.escFunction = this.escFunction.bind(this)
  }

  escFunction(event) {
    if (event.keyCode === 27) {
      this.props.onCloseClick()
    }
  }
  componentDidMount() {
    document.addEventListener('keydown', this.escFunction, false)
  }
  componentWillUnmount() {
    document.removeEventListener('keydown', this.escFunction, false)
  }

  render() {
    return (
      <Resource.Component
        fetchPolicy="no-cache"
        variables={{ id: this.props.id }}
      >
        {({ loading, error, data }) => {
          if (loading) return <div>Fetching</div>
          if (error) return <div>Error</div>
          if (!data) return <div>No data!</div>
          const resource = data.resource
          const detailAttributes: string[][] = [
            [
              'Title:',
              resource.title,
              'Years With HKS:',
              '' + resource.yearsWithHks
            ],
            [
              'Office:',
              resource.office,
              'Total Employment Years:',
              '' + resource.totalEmploymentYears
            ],
            [
              'Real Rate:',
              resource.realRate ? '' + resource.realRate : 'NA',
              'Generic Rate: ',
              resource.genericRate ? '' + resource.genericRate : 'NA'
            ],
            ['Current Role:', resource.laborCategory, 'Team:', resource.team],
            ['Sector:', resource.sector, '', '']
          ]

          return (
            <div className="fixed absolute--fill overflow-y-scroll">
              <div className="pa6">
                <article className="bg-white mw7-ns br2 ba b--black-30 mv2">
                  <button onClick={this.props.onCloseClick} className="close" />
                  <h1 className="f6 bg-washed-blue br3 br--top black-60 mv0 pv2 ph3">
                    Employee Details - {resource.firstName} {resource.lastName}
                  </h1>
                  <div className="dt pa2 bt b--black-10 w-100">
                    <div className="dtc v-mid pl4">
                      <img
                        alt=""
                        src={resource.thumbnailUrl}
                        className="br-100 w4 dib"
                        title={`Photo of ${resource.fullName}`}
                      />
                    </div>
                    <div className="dtc v-mid pl2">
                      <ul className="list pl0 mt0 measure center">
                        {detailAttributes.map((detail, index) => (
                          <ResourceAttributeRow
                            key={index}
                            title1={detail[0]}
                            value1={detail[1]}
                            title2={detail[2]}
                            value2={detail[3]}
                          />
                        ))}
                        <Registrations registrations={resource.registrations} />
                        <Projects
                          title="Current Projects"
                          id="currentProjects"
                          projects={resource.currentProjects}
                        />
                        <Projects
                          title="Planned Projects"
                          id="plannedProjects"
                          projects={resource.plannedProjects}
                        />
                      </ul>
                    </div>
                  </div>
                </article>
              </div>
            </div>
          )
        }}
      </Resource.Component>
    )
  }
}
export default ResourceDetailsPopUp
